import { ProductPriceTicketCustom } from 'Components/lines/product-price-ticket-custom/ProductPriceTicketCustom';
export default ProductPriceTicketCustom;
